module.exports = __webpack_public_path__ + "static/img/shipinhujiao.e70cf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shipinhujiao.png
// module id = Z/lP
// module chunks = 208